module.exports = __webpack_public_path__ + "static/media/slider_3_master_user_en.5a9cd846.svg";